export default __webpack_public_path__ + "static/media/87.26e3ad1d.png";